<div id="agenda-dialog-container">
  <!-- Header -->
  <div class="flex-space-between">
    <div class="title margin-right-1">{{ title | translate }}</div>
    <button mat-icon-button color="warn" (click)="closeDialog()">
      <mat-icon svgIcon="close-circle"></mat-icon>
    </button>
  </div>
  <container-element [ngSwitch]="data.type">
    <!-- Single class -->
    <ng-template #singleClass [ngSwitchCase]="'single_class'">
      <!-- Date -->
      <div class="date flex-start-center margin-top-1 padding-left-2">
        
        <span><i class="far fa-clock"></i> {{ start }} - {{ end }}</span>
      </div>

      <!-- Subject -->
      <div
        class="person flex-start-center margin-top-1 padding-left-2 margin-bottom-2"
      >
        
        <span><i class="fas fa-book"></i> {{ data.title }}</span>
      </div>
      
      
    
      <!-- state -->
      <div class="margin-top-1">
        {{ "state" | translate }}:
        <span
          [ngClass]="{
            'text-pendent': data.state == 0,
            'text-accepted': data.state == 1,
            'text-rejected': data.state == 3
          }"
          >{{ "status-" + data.state | translate }}</span
        >
      </div>
      <div>
        <span><i class="fas fa-user"></i> {{ data.user }}</span>
      </div>
      <!-- Actions -->
      <button
        mat-raised-button
        color="primary"
        class="margin-top-1 margin-bottom-05 text-uppercase agenda-dialog-main-btn"
        *ngIf="['1', '4'].includes(data.state) && allowJoin"
        (click)="joinClass()"
      >
        {{ "join-class" | translate }}
      </button>
    </ng-template>

    <!-- Group class -->
    <ng-template #groupClass [ngSwitchCase]="'group_class'">
      <!-- Date -->
      <div class="date flex-start-center margin-top-1 padding-left-2">
        
        <span><i class="far fa-clock"></i> {{ start }} - {{ end }}</span>
      </div>

      <!-- Title -->
      <div
        class="person flex-start-center margin-top-1 padding-left-2 margin-bottom-2"
      >
        
        <span><i class="fas fa-book"></i> {{ data.title }}</span>
      </div>


      <!-- state -->
      <div class="margin-top-1">
        {{ "state" | translate }}:
        <span
          [ngClass]="{
            'text-pendent': data.state == 0,
            'text-accepted': data.state == 1,
            'text-rejected': data.state == 3
          }"
          >{{ "status-" + data.state | translate }}</span
        >
      </div>
      <div>
        <span><i class="fas fa-users"></i> {{ data.user }}</span>
      </div>

      <!-- Actions -->
      <button
        mat-raised-button
        color="primary"
        class="margin-top-1 margin-bottom-05 text-uppercase agenda-dialog-main-btn"
        *ngIf="['1', '4'].includes(data.state) && allowJoin"
        (click)="joinClass()"
      >
        {{ "join-class" | translate }}
      </button>
    </ng-template>
    

  </container-element>
</div>
